<template>
  <div class="bloodPressure">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="血压" name="first">
        <el-table :data="tableData" :border="true">
          <el-table-column
            label="序号"
            width="80"
            align="center"
            type="index"
            prop=""
          >
          </el-table-column>
          <el-table-column label="测量时间" align="center" prop="DayTimestamp">
            <template slot-scope="scope" align="center">
              {{ scope.row.DayTimestamp | handtime}}
            </template>
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="DeviceType">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="收缩压" align="center" prop="HighPressure">
            <template slot-scope="scope" align="center">
              {{ scope.row.HighPressure || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="舒张压" align="center" prop="LowPressure">
            <template slot-scope="scope" align="center">
              {{ scope.row.LowPressure || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="脉搏" align="center" prop="Pulse">
            <template slot-scope="scope" align="center">
              {{ scope.row.Pulse || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          @current-change="changefn"
          :page-size="size"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { requestUserBpData } from "@/api/userApi";
import { handtime } from "@/utils/util";
export default {
  name: "bloodPressure",
  data() {
    return {
      activeName: "first",
      size: 10,
      page: 1,
      total: 0,
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created() {
    this.requestUserBpDatafn();
  },
  filters: {
    handtime,
  },
  methods: {
    changefn(index){
      this.page =index;
      this.requestUserBpDatafn();

    },
    async requestUserBpDatafn() {
      var res = await requestUserBpData({
        userId: this.$route.query.id,
        page: this.page,
        size: this.size,
      });
      this.tableData = res.data.data.result.list;
      this.total = res.data.data.result.count;
    },
  },
};
</script>

<style lang="less">
.bloodPressure {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>